import ApiBase from '../ApiBase';

class Message extends ApiBase {
    route = '/exhibitors/messages';
}

export default new Message();
